const FALLBACK_TEXT = "Could not reach the assistant. Nothing was changed. Try again.";

interface AssistantErrorBody {
  message?: string;
  ref?: unknown;
}

// `ref` is the reference the backend also logs for the failed request, so a
// person can report it and the cause is found without guessing.
export interface AssistantErrorEntry {
  kind: "error";
  text: string;
  ref?: string;
}

export function assistantErrorEntry(error: unknown): AssistantErrorEntry {
  const body = (error as { response?: { data?: { error?: AssistantErrorBody } } })?.response?.data
    ?.error;
  return {
    kind: "error",
    text: body?.message ?? FALLBACK_TEXT,
    ref: typeof body?.ref === "string" ? body.ref : undefined,
  };
}
